import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';

export interface SubmissionActivity {
  id: string;
  details: string;
  created_at: string;
  title: string;
  submission_id: string;
}

interface UseSubmissionActivitiesReturn {
  activities: SubmissionActivity[];
  isLoading: boolean;
}

export const useRecentActivity = (): UseSubmissionActivitiesReturn => {
  const { data, isLoading } = useQuery<SubmissionActivity[]>({
    queryKey: ['dashboard', 'activities'],
    queryFn: () =>
      API.authenticated.fetch('/dashboard/activities').then(r => r.json()),
  });

  return { activities: data ?? [], isLoading };
};
